import type {Component, OnChanges, OnChangesObject} from 'typings/portaro.fe.types';
import type ForeignDocumentDataService from './foreign-document.data-service';
import type {ForeignOccurrence, PlainAvailability} from 'typings/portaro.be.types';

export class KpFindInDatabasesComponentController implements KpFindInDatabasesComponentBindings, OnChanges<KpFindInDatabasesComponentBindings> {
    public recordId: string;

    public foreignOccurrences: ForeignOccurrenceWithAvailability[];

    /*@ngInject*/
    constructor(private foreignDocumentDataService: ForeignDocumentDataService) {
    }

    public async $onChanges(onChangesObj: OnChangesObject<KpFindInDatabasesComponentBindings>): Promise<any> {
        if (onChangesObj.recordId && onChangesObj.recordId.currentValue) {
            this.foreignOccurrences = await this.foreignDocumentDataService.getDocumentOccurrences(onChangesObj.recordId.currentValue) as ForeignOccurrenceWithAvailability[];
            // eslint-disable-next-line @typescript-eslint/no-misused-promises
            this.foreignOccurrences.forEach(async (occurrence) => occurrence.availability = await this.foreignDocumentDataService.getDocumentAvailability(occurrence.databaseId, parseInt(occurrence.itemId, 10)));
        }
    }
}

/**
 * @ngdoc component
 * @name kpFindInDatabases
 * @module uc.record
 *
 * @param {string} recordId Record id (UUID).
 *
 * @description
 *
 */
export default class KpFindInDatabasesComponent implements Component<KpFindInDatabasesComponentBindings> {
    public static componentName = 'kpFindInDatabases';

    public templateUrl = require('./kp-find-in-databases.tpl.ftl');

    public bindings = {
        recordId: '<'
    } as const;

    public controller = KpFindInDatabasesComponentController;
}

interface KpFindInDatabasesComponentBindings {
    recordId: string;
}

interface ForeignOccurrenceWithAvailability extends ForeignOccurrence {
    availability: PlainAvailability;
}